export const DEFAULT_FIELD_CONFIG = { auto_fields: true, fields: [] };

export const labelFor = (field, index) =>
  field && field.label && field.label.trim() ? field.label.trim() : `Detail ${index + 1}`;

export const makeField = () => ({
  id: `f_${Math.random().toString(36).slice(2, 10)}`,
  label: "",
  ai_instruction: "",
  enabled: true,
});

export const enabledFields = (config) =>
  (config?.fields || []).filter((f) => f.enabled);

// Returns [{...field, index, label}] for all enabled fields with resolved labels.
export const resolvedEnabledFields = (config) => {
  const fields = config?.fields || [];
  return fields
    .map((f, index) => ({ ...f, index, resolvedLabel: labelFor(f, index) }))
    .filter((f) => f.enabled);
};
